import { render, staticRenderFns } from "./OnboardingId.vue?vue&type=template&id=c886d220&"
import script from "./OnboardingId.vue?vue&type=script&lang=js&"
export * from "./OnboardingId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports